// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"social-icons-module--socialLinks--37xCY"};